import { HolidayModel, HolidayModelAPI } from '../../../../models';

export const getHolidaysListAdapter = (
    responseAPI: HolidayModelAPI[]
): HolidayModel[] => {
    return responseAPI
        ? responseAPI.map((day) => {
              return {
                  id: day.id,
                  name: day.name,
                  date: day.date,
              };
          })
        : [];
};
